<template>
    <div>
        <el-form ref="form" :model="form" label-position="left" label-width="70px" size="mini">
            <el-form-item v-if="this.systemConfig.zoneAutoOpenConditions.length ? false : true">（未设置自动开服条件）</el-form-item>
            <div v-for="(item, index) of this.systemConfig.zoneAutoOpenConditions" :key="item.seq">
                <el-form-item v-if="index != 0">或者</el-form-item>
                <el-form-item :label="`条件` + (index + 1) + `：`">
                    <el-select v-model="item.key" placeholder="请选择条件" @change="updateavailableConditions">
                        <el-option v-for="conitionItem in availableConditions" :key="conitionItem.value"
                            :label="conitionItem.label" :value="conitionItem.value" :hidden="conitionItem.used"></el-option>
                    </el-select>

                    ≥
                    <el-input v-if="getConditionValueType(item.key) == 'number'" v-model="item.value"
                        style="width: 200px"></el-input>
                    <el-input v-else v-model="item.value"
                        style="width: 200px"></el-input>
                    <el-button @click="onClickRemoveConditionBtn(index)" style="margin-left: 10px" icon="el-icon-delete"
                        circle></el-button>
                </el-form-item>
            </div>
            <el-form-item>
                <el-button @click="addCondition()" class="el-icon-plus">添加条件</el-button>
                <el-button type="primary" icon="el-icon-edit" @click="updateSystemConfigForAdminRoleNormal()"
                    style="margin-left: 10px">保存修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
    data() {   
        return {
            form: {},
            availableConditions: [], // 可用的条件
            systemConfig: {
                zoneAutoOpenConditions: [],
            },
        };
    },

    async created() {
        await this.loadAvailableConditionsOfZoneAutoOpen()
        await this.loadSystemConfigForAdminRoleNormal();
    },

    methods: {
        /**
         * 加载运营级别能够查看的系统设置
         */
        async loadSystemConfigForAdminRoleNormal() {
            let resData = (
                await axios.post(
                    `${util.getBackendApiBase()}/v1/admin/getSystemConfigForAdminRoleNormal`,
                    {},
                    {
                        headers: {
                            token: bizutil.getLoginUserToken(),
                        },
                    }
                )
            ).data;
            if (resData.code > 0) {
                this.$message.error(resData.message);
                return;
            }
            this.systemConfig = resData.data || {};

            this.updateavailableConditions()
        },

        /**
         * 加载可使用的自动开新区条件
         */
         async loadAvailableConditionsOfZoneAutoOpen() {
            let resData = (
                await axios.post(
                    `${util.getBackendApiBase()}/v1/admin/availableConditionsOfZoneAutoOpen`,
                    {},
                    {
                        headers: {
                            token: bizutil.getLoginUserToken(),
                        },
                    }
                )
            ).data;
            if (resData.code > 0) {
                this.$message.error(resData.message);
                return;
            }
            this.availableConditions = resData.data.availableConditions || [];
        },

        async updateSystemConfigForAdminRoleNormal() {
            for (
                    let j = 0;
                    j < this.systemConfig.zoneAutoOpenConditions.length;
                    j++
                ) {
                    this.systemConfig.zoneAutoOpenConditions[j].value.trim();
                    if (!this.systemConfig.zoneAutoOpenConditions[j].key) {
                        this.systemConfig.zoneAutoOpenConditions.splice(j, 1);
                    }

                    

                    // 输入检测
                    if (this.systemConfig.zoneAutoOpenConditions[j].type == 'number') {
                        let value = parseInt(this.systemConfig.zoneAutoOpenConditions[j].value);
                        if (value.toString() != this.systemConfig.zoneAutoOpenConditions[j].value || value < 0) {
                            console.log("value",value)
                            this.$alert("请检查输入", "提示", {
                                confirmButtonText: "确定",
                            });
                            return;
                        }
                    }
                }

            try {
                // 弹确认框
                await this.$confirm(`确认保存修改？`);
                let resData = (
                    await axios.post(
                        `${util.getBackendApiBase()}/v1/admin/updateSystemConfigForAdminRoleNormal`,
                        this.systemConfig,
                        {
                            headers: {
                                token: bizutil.getLoginUserToken(),
                            },
                        }
                    )
                ).data;
                if (resData.code > 0) {
                    this.$message({
                        message: resData.message,
                        type: "error",
                    });
                    return;
                }
                this.$message({
                    message: "修改成功",
                    type: "success",
                });
                this.systemConfigChange()
            } catch (e) { }
        },

        updateavailableConditions() {
            for (let i = 0; i < this.availableConditions.length; i++) {
                this.availableConditions[i].used = false
                for (
                    let j = 0;
                    j < this.systemConfig.zoneAutoOpenConditions.length;
                    j++
                ) {
                    if (
                        this.availableConditions[i].value ==
                        this.systemConfig.zoneAutoOpenConditions[j].key
                    ) {
                        this.availableConditions[i].used = true
                        break;
                    }
                }
            }
        },

        addCondition() {
            this.systemConfig.zoneAutoOpenConditions.push({
                key: "",
                value: "",
            });
        },
        onClickRemoveConditionBtn(index) {
            this.systemConfig.zoneAutoOpenConditions.splice(index, 1);
            this.updateavailableConditions()
        },

        getConditionValueType(key){
            for (let i = 0; i < this.availableConditions.length; i++) {
                if(this.availableConditions[i].value == key){
                    return  this.availableConditions[i].type
                }
            }

            return ""
        },

        systemConfigChange(){
            // 序列化再反序列化，进行一次深拷贝，防止直接把指针传递出去
            this.$emit('systemConfigChange', JSON.parse(JSON.stringify(this.systemConfig)));
        },
    },
};
</script>